export default __webpack_public_path__ + "static/media/jam_alert.0319344e.svg";